import toastr from 'toastr';

toastr.options = {
    "closeButton": true,
    "debug": true,
    "newestOnTop": true,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};

window.toastr = toastr;

import Newsletters from '../../../assets/js/Newsletters/Newsletters';
Newsletters();

import GaAnalytics from '../../../assets/js/Analytics/GaAnalytics.js';
GaAnalytics();